import { Image } from '@cian/ui-kit/image';
import classNames from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';
import { prepareSlides } from './utils/prepareSlides';
import { IImage } from '../../types/newbuildingHeader';
import { Carousel } from '../Carousel';

interface INewbuildingHeaderSliderProps {
  images: IImage[];
  onClick?(): void;
}

export const NewbuildingHeaderSlider = (props: INewbuildingHeaderSliderProps) => {
  const media = prepareSlides(props.images);

  const handleClick = React.useCallback(() => {
    const { onClick } = props;

    if (onClick) {
      onClick();
    }
  }, []);

  if (media.length === 0) {
    return (
      <div className={classNames(styles['cont'], styles['cont--empty'])}>
        <Image src="" />
      </div>
    );
  }

  return (
    <div className={styles['slider']} onClick={handleClick}>
      <Carousel media={media} />
    </div>
  );
};
